import React from 'react';
import { QuantityContainer } from './ButtonInput.styled';
//@ts-ignore
import { Secondary } from '../../../eden/eden-buttons/lib/cjs';

interface ButtonInputProps {
    lowerQuantity: () => void;
    raiseQuantity: () => void;
    currentInput: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    label: string;
    currentValue: number;
    min?: number;
    max?: number;
    id?: string;
    ref?: React.RefObject<HTMLInputElement>;
    maxQuantityError?: () => void;
    maxQuantityErrorReset?: (boolean: boolean) => void;
}

//@ts-ignore
export const ButtonInput: React.FC<ButtonInputProps> = ({
    lowerQuantity,
    raiseQuantity,
    min,
    max,
    currentInput,
    onChange,
    onBlur,
    label,
    currentValue,
    id,
    ref,
    maxQuantityError,
    maxQuantityErrorReset
}) => {
    return (
        <QuantityContainer>
            <Secondary onClick={currentInput > 0 ? () => lowerQuantity() : null}>-</Secondary>
            <input
                type='number'
                min={min}
                className='lds-quantity-input'
                pattern='[0-9]*'
                value={currentInput}
                onChange={onChange}
                onBlur={onBlur}
                aria-live='polite'
                aria-label={label}
                role='spinbutton'
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={currentValue}
                id={id}
                ref={ref}
            />
            <Secondary
                onClick={() =>
                    max && currentInput < max
                        ? raiseQuantity()
                        : maxQuantityErrorReset
                        ? maxQuantityErrorReset(true)
                        : maxQuantityError
                        ? maxQuantityError()
                        : null
                }
            >
                +
            </Secondary>
        </QuantityContainer>
    );
};
